import config from '@haaretz/l-config';
import usePageType from '@haaretz/s-atoms/pageType';
import { usePathname as useAppPathname } from 'next/navigation';
import { useRouter } from 'next/router';
const appType = config.get('appType');
const landingPages = [
    '/supportHaaretz'
];
function usePagesPathname() {
    const router = useRouter();
    return router.pathname;
}
export default function useBiPageType() {
    const pageType = usePageType();
    // eslint-disable-next-line react-compiler/react-compiler
    const usePathname = appType === 'promotions-page' ? usePagesPathname : useAppPathname;
    // eslint-disable-next-line react-compiler/react-compiler
    const pathname = usePathname();
    if (appType === 'promotions-page') {
        if (landingPages.some((landingPage)=>pathname?.endsWith(landingPage))) {
            return 'landing_page';
        }
        return 'Promotions';
    }
    if (pathname?.includes('ty-search')) {
        return 'Search';
    }
    if (pathname?.startsWith('/chatbot/')) {
        return 'Chatbot';
    }
    if (appType === 'login') {
        return 'Login';
    }
    if (pageType.endsWith('Article')) {
        return 'Article';
    }
    if (pageType === 'Homepage') {
        return pageType;
    }
    return 'Section';
}

//# sourceMappingURL=useBiPageType.js.map